import React, { useEffect, useRef, useState } from 'react';
import Header from '../../components/header';
import Layout from '../../components/layout';
import { AgGridReact } from 'ag-grid-react';
import { AllCommunityModule, ModuleRegistry } from "ag-grid-community";
import Icon from '../../components/icons';
import Drawer from '../../components/Drawer';


import { Dropdown, Menu } from '../../components/Dropdown';
import Button from '../../components/elements/button';
import barnhouseImg from '../../images/barn_house_icon.png';
import { useFacilitiesApi } from '../../store/api/hooks/facilitiesApiHook';
import toast from 'react-hot-toast';
//import CreateSubFacilitiesModal from './_components/createSubFacilities.modal';
import { useDialog } from '../../store/api/hooks/dialogHook';
import moment from 'moment';
import { DATE_FORMAT, PAGE_SIZE } from '../../_common/constant';
import Pagination from '../../components/pagination';
import Search from '../../components/search';
import { downloadExcel, downloadPDF, localDate, localTime, showLocalDate, getPermissionInfo } from '../../_common/functions';
import Loader from '../../components/loader';
import Filters from '../../components/filters';
import { filterConfigType, Option } from '../../_config/types';
import { useAllCitySelector, useAllCountySelector, useDepreciationApportionsSelector, useDepreciationMethodsSelector, useElectricityProvidersSelector, useFacilityManagersSelector, useGasProvidersSelector, useServiceTechsSelector, useStatesSelector, useTeamsSelector, useTelephoneProvidersSelector, useWaterProvidersSelector } from '../../store/selectors/masterSelector';
import { useCommonApi } from '../../store/api/hooks/commonApiHook';
import { StatusStaticCell, titleCell } from '../../components/elements/function';
import { useDepreciationApi } from '../../store/api/hooks/depreciationApiHook';
import CreateWorkOrder from './_components/createWorkOrder';
import { useWorkOrderApi } from '../../store/api/hooks/workOrderApiHook';
import { useLocation, useNavigate } from 'react-router-dom';
import { URLS } from '../../_config';
import CalendarWO from './_components/calendarWO';
import { useWorkRequestApi } from '../../store/api/hooks/workRequestApiHook';
import { resolve } from 'path';
import { rejects } from 'assert';
import KanbanViewWorkOrder from './_components/kanbanWorkOrder';
import CreateScheduler from '../MaintenanceCalendar/_components/createScheduler';
import { useUserSelector } from '../../store/selectors/userSelector';
ModuleRegistry.registerModules([AllCommunityModule]);

const WorkOrder: React.FC = () => {
    const loggedinuser: any = useUserSelector();
    const location = useLocation();

    const facilityApi: any = useFacilitiesApi();
    const commonApi: any = useCommonApi();
    const workOrderApi: any = useWorkOrderApi();
    const workRequestAPI: any = useWorkRequestApi();

    const preventivewoRef = useRef<any>(null);

    const { confirm } = useDialog();

    const [currentPage, setCurrentPage] = useState<number>(1);

    const [searchParam, setSearchParam] = useState<string>('');
    const [totalRecords, setTotalRecords] = useState<number>(0);

    const [facilityoption, setFacilityoption] = useState<any>([]);
    const [priorityoption, setPriorityoption] = useState<any>([]);
    const [statusoption, setStatusoption] = useState<any>([]);
    const [assigntypeoption, setAssigntypeoption] = useState<any>([]);
    const [userTypeID, setUserTypeID] = useState<any>([]);

    const [rowData, setrowData] = useState<any>(null)
    const [gridApi, setGridApi] = useState<any>(null);
    const [gridColumnApi, setGridColumnApi] = useState<any>(null);
    const [editData, setEditData] = useState<any>(null);

    const [view, setView] = useState<`list` | `calendar` | `kanban`>(`list`);
    const [includePMWO, setIncludePMWO] = useState<boolean>(false);
    const [includeCloseWO, setIncludeCloseWO] = useState<boolean>(false);

    const navigate = useNavigate();
    const states: Option[] | null = useStatesSelector();

    const users = useFacilityManagersSelector();
    const electricity = useElectricityProvidersSelector();
    const createDrawerRef: any = useRef();
    const createScheduleDrawerRef: any = useRef();
    const createSubFacilityModalRef: any = useRef();
    const filtersRef: any = useRef();
    const [filters, setFilters] = useState<any>({});
    const [filtersApplied, setFiltersApplied] = useState<any>({ generalFilter: false });
    const [filtersInitialized, setFiltersInitialized] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);

    // Load filters from localStorage on component mount
    useEffect(() => {
        const savedFilters = localStorage.getItem('workOrderFilters');
        if (savedFilters) {
            try {
                const parsedFilters = JSON.parse(savedFilters);
                setFilters(parsedFilters);
            } catch (error) {
                console.error('Error parsing saved filters:', error);
                setFilters({});
            }
        } else {
            setFilters({});
        }
        setFiltersInitialized(true);
    }, []);

    // Save filters to localStorage when filters change
    useEffect(() => {
        if (Object.keys(filters).length > 0) {
            localStorage.setItem('workOrderFilters', JSON.stringify(filters));
        }
    }, [filters]);

    useEffect(() => {
        if (users == null) {
            commonApi.GetUserList({
                pageNo: 1,
                pageSize: 1000
            }, (resp: any) => { }, (error: any) => { })
        }
    }, [users])

    const filterConfig: filterConfigType[] = [
        { name: 'WO Number', type: 'text', key: 'woCode' },
        { name: 'Facility', type: 'dropdown', key: 'facilityIDs', options: facilityoption ? facilityoption : [] },
        { name: 'Priority', type: 'dropdown', key: 'woPriorityIDs', options: priorityoption ? priorityoption : [] },
        { name: 'Status', type: 'dropdown', key: 'woStatusIDs', options: statusoption ? statusoption : [] },
        { name: 'Assign Type', type: 'dropdown', key: 'woAssignmentTypeIDs', options: assigntypeoption ? assigntypeoption : [] },
        { name: 'Assigned to', type: 'dropdown', key: 'assignedToIDs', options: users ? users : [] },
        { name: 'Work Request ID', type: 'text', key: 'workRequestID' },
        { name: 'Planned Start Date', type: 'date', key: 'startDate' },
        { name: 'Planned End Date', type: 'date', key: 'endDate' },
        

    ];






    const columnDefs = [
        { headerCheckboxSelection: true, checkboxSelection: true, width: 50, headerClass: 'bg-[#f0f0f0]' },
        {
            headerName: 'Task No', field: 'workOrderCode', headerClass: 'bg-[#f0f0f0]', width: 250, cellRenderer: (data: any) => {
                return (
                    <p className='hover:text-primary font-semibold cursor-pointer'> {data.value}  </p>
                )
            }, onCellClicked: (param: any) => {
                navigate(URLS.WORK_ORDER_DETAILS(param.data.workOrderID));
            }
        },

        { headerName: 'Description', field: 'description', headerClass: 'bg-[#f0f0f0]', width: 140, flex: 1, cellRenderer: titleCell },
        {
            headerName: 'Facility', field: 'facilityName', headerClass: 'bg-[#f0f0f0]', minWidth: 160, cellRenderer: (params: any) => {
                return (
                    <p>
                        {params.data.facilityName}
                    </p>
                )
            }, tooltipValueGetter: (params: any) => {
                return params.data.facilityName + (params.data.subFacilityName ? `, ${params.data.subFacilityName}` : '')
            }
        },
        {
            headerName: 'Start Date', field: 'startDate', headerClass: 'bg-[#f0f0f0]', width: 140, cellStyle: { textAlign: 'center' }, cellRenderer: (data: any) => {
                return (
                    <p className={''} title={(+data.data.woStatusID >= 4) ? ((data.data.originalStartDate ? moment.utc(data.data.originalStartDate).local().format(`MM/DD/YYYY hh:mm A`) : '--')) : (data.data.startDate ? moment.utc(data.data.startDate).local().format(`MM/DD/YYYY hh:mm A`) : `--`)}>
                        {data.value ? showLocalDate(data.value) : `--`}
                    </p>
                )
            }/*, tooltipValueGetter: (params: any) => {
                return +params.data.woStatusID >= 4 ? (
                    //Actual start datetime
                    (params.data.originalStartDate ? moment.utc(params.data.originalStartDate).local().format(`MM/DD/YYYY hh:mm A`) : '')
                ) : (
                    params.data.startDate? moment.utc(params.data.startDate).local().format(`MM/DD/YYYY hh:mm A`): `--`
                )
            }*/
        },
        {
            headerName: 'End Date', field: 'endDate', headerClass: 'bg-[#f0f0f0]', width: 140, cellRenderer: (data: any) => {
                return (
                    <p className={``} title={+data.data.woStatusID >= 4 ? (data.data.originalEndDate ? moment.utc(data.data.originalEndDate).local().format(`MM/DD/YYYY hh:mm A`) : `--`) : (data.data.endDate ? moment.utc(data.data.endDate).local().format(`MM/DD/YYYY hh:mm A`) : `--`)}>{data.value ? showLocalDate(data.value) : `--`}</p>
                )
            }/*, tooltipValueGetter: (params: any) => {
                return +params.data.woStatusID >= 4 ? (
                    //Actual start datetime
                    (params.data.originalEndDate ? moment.utc(params.data.originalEndDate).local().format(`MM/DD/YYYY hh:mm A`) : ``)
                ) : (
                    params.data.endDate? moment.utc(params.data.endDate).local().format(`MM/DD/YYYY hh:mm A`): `--`
                )
            }*/
        },
        { headerName: 'Priority', field: 'priorityName', headerClass: 'bg-[#f0f0f0]', width: 160, cellRenderer: titleCell },
        //{ headerName: 'Status', field: 'woStatusName', headerClass: 'bg-[#f0f0f0]' , width: 160,   cellRenderer:titleCell},
        { headerName: 'Status', field: 'woStatusName', headerClass: 'bg-[#f0f0f0]', width: 200, cellRenderer: StatusStaticCell },
        {
            headerName: 'Assignment Type', field: 'woAssignmentTypeName', headerClass: 'bg-[#f0f0f0]', width: 160, cellRenderer: (params: any) => {
                return (
                    <div className='text-ellipsis overflow-hidden' title={`${params.value}`}>{params.value || `--`}</div>
                )
            }
        },

        {
            headerName: 'Action',
            field: 'action',
            headerClass: 'bg-[#f0f0f0] text-center',
            pinned: 'right',
            width: 90,
            cellRenderer: (params: any) => {
                return (
                    <div className='relative h-full w-full flex items-center justify-center'>
                        <Icon name='threedote' size={1.25} className='text-[#000000]' onClick={(e: any) => {
                            e.stopPropagation();
                            e.preventDefault();
                            const dropdown: any = document.querySelector('.action-dropdown');
                            if (dropdown) {
                                dropdown.focus();
                            }
                            return false;
                        }} />
                        <select
                            onChange={(e) => {
                                const action = e.target.value;
                                if (!getPermissionInfo(location.pathname, action, loggedinuser)) {
                                    toast.error(`You don't have ${action} permission`);
                                    e.target.selectedIndex = -1;
                                    return;
                                }
                                handleActionChange(e, params);
                                e.target.selectedIndex = -1;
                            }}
                            onFocus={(e) => {
                                e.target.selectedIndex = -1;
                            }
                            }
                            className="action-dropdown"
                            style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                opacity: 0,
                                cursor: "pointer",
                            }}
                        >
                            {(() => {
                                switch (params.data.woStatusID) {
                                    case 1: {
                                        return (
                                            <>
                                                <option value="edit" disabled={!getPermissionInfo(location.pathname, "Edit", loggedinuser)}>Edit</option>
                                                <option value="delete" disabled={!getPermissionInfo(location.pathname, "Delete", loggedinuser)}>Delete</option>
                                                {/*
                                                <option value="schedule">Schedule</option>
                                                <option value="cancel">Cancel</option>
                                                */}
                                            </>
                                        )
                                    }
                                    case 7: {
                                        return (
                                            <>
                                                <option value="edit" disabled={!getPermissionInfo(location.pathname, "Edit", loggedinuser)}>Edit</option>
                                                <option value="delete" disabled={!getPermissionInfo(location.pathname, "Delete", loggedinuser)}>Delete</option>
                                                {/*
                                                <option value="start">Start</option>
                                                <option value="cancel">Cancel</option>
                                                */}
                                            </>
                                        )
                                    }
                                    case 2: {
                                        return (
                                            <>
                                                <option value="edit" disabled={!getPermissionInfo(location.pathname, "Edit", loggedinuser)}>Edit</option>
                                                <option value="delete" disabled={!getPermissionInfo(location.pathname, "Delete", loggedinuser)}>Delete</option>
                                                {/*
                                                <option value="start">Start</option>
                                                <option value="cancel">Cancel</option>
                                                */}
                                            </>
                                        )
                                    }
                                    case 4: {
                                        return (
                                            <>
                                                <option value="delete" disabled={!getPermissionInfo(location.pathname, "Delete", loggedinuser)}>Delete</option>
                                                {/*
                                                <option value="close_complete">Close - Complete</option>
                                                <option value="close_incomplete">Close - In Complete</option>
                                                <option value="cancel">Cancel</option>
                                                */}
                                            </>
                                        )
                                    }
                                    case 5:
                                    case 6:
                                    case 3:
                                    default: {
                                        return (
                                            <option value="delete" disabled={!getPermissionInfo(location.pathname, "Delete", loggedinuser)}>Delete</option>
                                        )
                                    }
                                }
                            })()}
                        </select>
                    </div>
                )
            }
        },
    ];

    const handleActionChange = (e: any, params: any) => {
        const action = e.target.value;
        const rowData = params.data;
        switch (action) {
            case "edit":
                // Implement edit action
                console.log("Edit action for row: ", rowData);
                createDrawerRef.current.open();
                // Set edit data after a small delay to ensure drawer is fully mounted
                setTimeout(() => {
                    setEditData(rowData);
                }, 100);
                break;
            case "delete":
                // Implement delete action
                confirm({
                    type: 'delete',
                    title: 'Delete Facility',
                    message: 'Are you sure you want to delete this Task?',
                    onConfirm: () => {
                        const payload = { workOrderID: rowData.workOrderID };
                        workOrderApi.DeleteWorkOrder(payload, (resp: any, msg: any) => {
                            toast.success(msg);
                            GetWorkOrderList();
                        }, (error: any) => {
                            console.log('error =>', error);
                            toast.error(error);
                        });
                    }
                });

                break;
            case "duplicate":
                // Implement view action
                console.log("duplicate action for row: ", rowData);
                break;
            case "qr":
                // Implement qr action
                console.log("qr action for row: ", rowData);
                const payload = { qrFacilityList: [{ facilityID: rowData.facilityID, qty: 1 }], facilityNameInQR: true };
                facilityApi.ExportQrCode(payload, (resp: any) => { downloadPDF(resp, 'FacilityQR') },
                    (error: any) => {
                        toast.error(error);
                    }
                );
                break;
            case "add-sub":
                // Implement add sub action
                console.log("Add sub action for row: ", rowData);

                createSubFacilityModalRef.current.showModal();
                break;
            default:
                console.log("Unknown action: ", action);
        }
        e.target.selectedIndex = -1;
    };

    const onGridReady = (params: any) => {
        setGridApi(params.api);
        setGridColumnApi(params.columnApi);
    };

    const getSelectedRows = () => {
        const selectedNodes = gridApi?.getSelectedNodes();
        const selectedData = selectedNodes.map((node: any) => node.data);
        return selectedData;
    };

    const onRowClicked = (event: any) => {
        if (!event.event.target.closest('input[type="checkbox"]')) {
            event.node.setSelected(false); // Unselect row if it's clicked, not by checkbox
        }
    };


    const onBulkExportPdf = () => {
        const selectedData = getSelectedRows();
        const payload: any = {};
        if (selectedData.length > 0) {
            const workOrderIDs = selectedData.map((asset: any) => asset.workOrderID).join(',');
            payload.workOrderIDs = workOrderIDs;
        }
        workOrderApi.ExportToPDF(
            payload,
            (resp: any) => {
                downloadPDF(resp, 'WorkOrderPdf')
            },
            (error: any) => {
                console.log("error =>", error);
                toast.error(error);
            }
        );
    };

    const onBulkExportCsv = async () => {
        const selectedData = getSelectedRows();
        const payload: any = {};
        if (selectedData.length > 0) {
            const workOrderIDs = selectedData.map((asset: any) => asset.workOrderID).join(',');
            payload.workOrderIDs = workOrderIDs;
        }
        workOrderApi.ExportToXLS(
            payload,
            (resp: any) => { downloadExcel(resp, 'WorkOrderXls') },
            (error: any) => {
                console.log("error =>", error);
                toast.error(error);
            }
        );
    };

    const onBulkPrintQR = () => {
        const selectedData = getSelectedRows();
        console.log("Selected Data for Deletion:", selectedData);
        if (selectedData.length == 0) {
            toast.error("Nothing is selected")
        } else {
            let qrList: any = [];
            selectedData.map((row: any) => qrList.push({ facilityID: row.facilityID, qty: 1 }));
            const payload = { qrFacilityList: qrList, facilityNameInQR: true };
            facilityApi.ExportQrCode(payload, (resp: any) => { downloadPDF(resp, 'FacilityQR') },
                (error: any) => {
                    console.log("error =>", error);
                    toast.error(error);
                }
            );
        }
    };

    const GetWorkOrderList = () => {
        setLoading(true);
        const payload: any = {
            pageSize: PAGE_SIZE,
            pageNumber: currentPage,
            searchParam: searchParam,
            woStatusIDs: '1,2,4,7',
        };

        if(loggedinuser.userTypeID===4){
            payload.assignedToIDs = loggedinuser?.userID;
        }

        /* if (preventivewoRef?.current?.checked) {
            payload.schedulerID = 0;
        } */

        if (includePMWO) {
            payload.schedulerID = 0;
        }
        if (includeCloseWO) {
            payload.woStatusIDs = '5,6,3,1,2,4,7';
        }

        if (filters) {
            Object.keys(filters).map((key: any) => {
                if (filters[key]) {
                    if (key === `startDate` || key === `endDate`) {
                        payload[key] = moment(filters[key]).format(`YYYY-MM-DD`); // Format date to YYYY-MM-DD
                    } else {
                        payload[key] = filters[key];
                    }
                }
            });
        }

        if (loggedinuser && getPermissionInfo(location.pathname, "Can Access Only Own Task", loggedinuser)) {
            payload.canAccessOwnWOOnly = true;
        }
        if (loggedinuser && getPermissionInfo(location.pathname, "Can Access Tasks where the related Request is owned by self", loggedinuser)) {
            payload.canAccessOwnWOOnly = true;
            payload.canAccessWOByOwnRequest = true;
        }

        setrowData(null);
        workOrderApi.GetWorkOrderList(payload, (resp: any) => {
            setrowData(resp.workOrderList ? resp.workOrderList : []);
            // console.log('resp =>', {resp, payload, filters});

            setTotalRecords(resp.totalRecord);
            setLoading(false);
        }, (error: any) => {
            console.log('error =>', error);
            toast.error(error);
            setLoading(false);
        });
    };


    const init_page_data = async () => {
         // Fetch user data first
        /* try {
            await new Promise((resolve, reject) => {
                commonApi.GetUserList({id: loggedinuser?.userID}, (resp: any) => {
                    setUserTypeID(resp.userList[0].userTypes.userTypeID);
                    resolve(resp);
                }, (error: any) => {
                    console.log("error =>", error);
                    toast.error(error);
                    reject(error);
                });
            });
        } catch (error: any) {
            // Handle error if needed
        } */

        /* const getuser = await new Promise((resolve, reject) => {
            commonApi.GetUserList({id: loggedinuser?.userID}, (resp: any) => {
                setUserTypeID(resp.userList.userTypes[0].userTypeID);

            }, (error: any) => {
                console.log("error =>", error);
                toast.error(error);
                reject(error);
            });
        }).catch((error: any) => []); */
        

        // Fetch facility list
        const facilityapiresp = await new Promise((resolve, reject) => {
            facilityApi.getFacilityList({}, (resp: any) => {
                let facilitylist: any = [];
                resp.facilityList.map((facilist: any) => {
                    facilitylist.push({
                        label: facilist.facilityName,
                        value: facilist.facilityID,
                        data: facilist
                    });
                });
                resolve(facilitylist);
            }, (error: any) => {
                console.log("error =>", error);
                toast.error(error);
                reject(error);
            });
        }).catch((error: any) => []);
        setFacilityoption(facilityapiresp);

        // Fetch priority list
        const priorityapiresp = await new Promise((resolve, reject) => {
            workRequestAPI.GetPriorityList({}, (resp: any) => {
                let prioritylist: any = [];
                resp.workRequestPriorityList.map((facilist: any) => {
                    prioritylist.push({
                        label: facilist.workRequestPriorityName,
                        value: facilist.workRequestPriorityID,
                        data: facilist,
                    });
                });
                resolve(prioritylist);
            }, (error: any) => {
                console.log("error =>", error);
                toast.error(error);
                reject(error);
            });
        }).catch((error: any) => []);
        setPriorityoption(priorityapiresp);

        // Fetch status list            
        const statusapiresp = await new Promise((resolve, reject) => {
            workOrderApi.GetWOStatusList({}, (resp: any) => {
                let deptlist: any = [];
                resp.workOrderStatusList.map((facilist: any) => {
                    deptlist.push({
                        label: facilist.woStatusName,
                        value: facilist.woStatusID,
                        data: facilist
                    });
                });
                resolve(deptlist);
            }, (error: any) => {
                console.log("error =>", error);
                toast.error(error);
                reject([])
            }
            );
        }).catch((error: any) => []);
        setStatusoption(statusapiresp);

        // Fetch assignment type list
        const assignmenttypeapiresp = await new Promise((resolve, reject) => {
            workOrderApi.GetWOAssignmentTypeList({}, (resp: any) => {
                let deptlist: any = [];
                resp.workOrderAssignmentTypeList.map((assignmentType: any) => {
                    deptlist.push({
                        label: assignmentType.woAssignmentTypeName,
                        value: assignmentType.woAssignmentTypeID,
                        data: assignmentType
                    });
                });
                resolve(deptlist);
            }, (error: any) => {
                console.log("error =>", error);
                toast.error(error);
                reject([]);
            });
        }).catch((error: any) => []);
        setAssigntypeoption(assignmenttypeapiresp);

    };

    useEffect(() => {
        init_page_data();
    }, []);

    // Call GetWorkOrderList only after filters are initialized
    useEffect(() => {
        if (filtersInitialized && view === 'list') {
            GetWorkOrderList();
        }
    }, [filters, filtersInitialized]);

    useEffect(() => {
        if (gridApi?.current) {
            // Auto size all columns based on their content
            gridApi?.current.sizeColumnsToFit();
        }
    }, [gridApi]);

    /*
    useEffect(() => {
        if (rowData) {
            GetWorkOrderList();
        }
    }, [currentPage, searchParam, filters]); 
    */

    useEffect(() => {
        if (view === 'list' && filtersInitialized) {
            GetWorkOrderList();
        }
        
        const hasActiveFilters = filterConfig.some((filter) => filters[filter.key]);
        setFiltersApplied({
            generalFilter: hasActiveFilters,
        });
    }, [currentPage, searchParam, filters, view, includePMWO, includeCloseWO]);


    const createWorkOrderOn = (date: any) => {
        createDrawerRef.current.open();
        setEditData(null);
        console.log('createWorkOrderOn date =>', date);
        if (createFacilityRef?.current) {
            createFacilityRef.current.setValue('startDate', date.toDate());
            createFacilityRef.current.setValue('endDate', date.toDate());
            createFacilityRef.current.setValue('startTime', moment());
            createFacilityRef.current.setValue('endTime', moment().add(1, 'hour'));
        }
    };
    const createScheduleOn = (date: any) => {
        createScheduleDrawerRef.current.open();
        if (createScheduleRef?.current) {
            createScheduleRef.current.setValue('planStartDate', date.toDate());
            createScheduleRef.current.setValue('startTime', moment());
        } else {
            console.error('createScheduleRef is not defined');
        }
    };

    const createFacilityRef: any = useRef();
    const createScheduleRef: any = useRef();

    return (
        <Layout>
            <Header title='Task List'>
                <Header.Right>
                    <div className='border border-primary rounded-md overflow-hidden'>
                        <Button theme={view == 'list' ? 'primary' : 'light'} className='!rounded-none !border-0 !w-14 !border-r border-primary' onClick={() => { setView('list') }}><Icon name={`list`} /></Button>
                        <Button theme={view == 'kanban' ? 'primary' : 'light'} className='!rounded-none !border-0 !w-14 !border-r border-primary' onClick={() => { setView('kanban') }}><Icon name={`kanban`} /></Button>
                        <Button theme={view == 'calendar' ? 'primary' : 'light'} className='!rounded-none !border-0 !w-14' onClick={() => { setView('calendar') }}><Icon name={`calendar`} /></Button>
                    </div>
                    <Drawer _ref={createDrawerRef} onClose={() => {
                        console.log('close drawer', createFacilityRef?.current?.reset);
                        createFacilityRef?.current?.reset()
                        createFacilityRef?.current?.reset_re_render_vars();
                        setEditData(null)
                    }} outsideClose={false}>
                        <Drawer.Button>
                            <Button disabled={!getPermissionInfo(location.pathname, "Add", loggedinuser)}>Create New Task</Button>
                        </Drawer.Button>
                        <Drawer.Content title={editData ? 'Edit Task' : 'Create New Task'} className='!w-[45rem]'>{/*!w-[39.563rem]*/}
                            {!getPermissionInfo(location.pathname, editData ? "Edit" : "Add", loggedinuser) ? (
                                <div className="p-4 text-red-500">
                                    You don’t have permission to access this form.
                                </div>
                            ) : (
                                <CreateWorkOrder _ref={createFacilityRef} editData={editData} onCreate={() => {
                                    setEditData(null);
                                    GetWorkOrderList();
                                    if ([`kanban`, `calendar`].includes(view)) {
                                        window.dispatchEvent(new CustomEvent(`page_tab_WO_created`, { detail: { message: { ACTION: `RELOAD`, data: null } } }));
                                    }
                                    createDrawerRef?.current?.close();
                                }} onCancel={() => {
                                    GetWorkOrderList();
                                    setEditData(null);
                                    createDrawerRef?.current?.close()
                                }} />)}
                        </Drawer.Content>
                    </Drawer>





                    <Drawer
                        _ref={createScheduleDrawerRef}
                        onClose={() => { }}
                        outsideClose={false}
                        isAfterOpenRender={false}
                    >
                        <Drawer.Button>
                            <Button disabled={!getPermissionInfo('/maintenance-calender', "Add", loggedinuser)}>Create Schedule PM</Button>
                        </Drawer.Button>
                        <Drawer.Content title={"Create New Schedule"} className="!w-[45rem]">
                            {!getPermissionInfo('/maintenance-calender', "Add", loggedinuser) ? (
                                <div className="p-4 text-red-500">
                                    You don't have permission to access this form.
                                </div>
                            ) : (
                                <CreateScheduler
                                    _ref={createScheduleRef}
                                    editData={null}
                                    onCreate={() => {
                                        createScheduleDrawerRef?.current?.close();
                                    }}
                                    onCancel={() => {
                                        createScheduleDrawerRef?.current?.close();
                                    }}
                                    prefillData={null}

                                />)}
                        </Drawer.Content>
                    </Drawer>
                    <Dropdown>
                        <Dropdown.Button>
                            <Button theme='secondary' disabled={view !== 'list'}>Bulk Actions</Button>
                        </Dropdown.Button>
                        <Dropdown.Content title='Create New Facility' className='!w-[39.563rem]'>
                            {/* <Menu onClick={onBulkPrintQR}>Move Assets</Menu> */}
                            <Menu disabled={!getPermissionInfo(location.pathname, "Export", loggedinuser)} onClick={onBulkExportCsv}>Export excel / csv </Menu>
                            <Menu disabled={!getPermissionInfo(location.pathname, "Export", loggedinuser)} onClick={onBulkExportPdf}>Export pdf</Menu>

                        </Dropdown.Content>
                    </Dropdown>
                </Header.Right>
            </Header>
            {view == 'list' && (
                <>
                    <div className='flex items-center justify-between pl-5 pr-3 border-b border-gray-200 h-[3.75rem]'>
                        <Pagination
                            perPage={PAGE_SIZE}
                            totalRecords={totalRecords}
                            onPageChange={setCurrentPage}
                            currentPage={currentPage}
                        />
                        <div className={`flex items-center gap-4`}>
                            {/* <div>
                                <label className='flex items-center gap-2 cursor-pointer'>
                                    <input type={`checkbox`} ref={preventivewoRef} onClick={(e) => {
                                        if (currentPage > 1)
                                            setCurrentPage(1);
                                        else
                                            GetWorkOrderList();
                                    }} />
                                    <span className={`block text-[0.8rem]`}>Show Preventive Maintenance Workorder </span>
                                </label>
                            </div> */}
                            <Search onSearch={setSearchParam} placeholder='Search by task no or facility' />
                        </div>
                    </div>
                    <div className='bg-[#FAFAFA] w-full'>
                        <div className='flex justify-between px-5 py-2 items-center'>

                            {/* Left side */}
                            <div className='flex gap-4 items-center'>
                                <Button
                                    theme='light'
                                    onClick={() => filtersRef.current.showModal()}
                                >
                                    Filter{" "}
                                    <Icon
                                        name='filter'
                                        size={1.40}
                                        className={filtersApplied.generalFilter ? "text-blue-700" : ""}
                                    />
                                </Button>
                                <p
                                    className='text-primary font-semibold text-sm cursor-pointer'
                                    onClick={() => { 
                                        setFilters({});
                                        localStorage.removeItem('workOrderFilters');
                                    }}
                                >
                                    Clear Filters
                                </p>
                            </div>

                            {/* Right side buttons */}
                            <div className='border border-primary rounded-md overflow-hidden flex'>
                                <Button
                                    theme={includePMWO ? 'blue' : 'light'}
                                    className={`!rounded-none !border-0 !border-r ${includePMWO ? 'border-primary' : 'border-gray-300'} px-3`}
                                    onClick={() => {
                                        setIncludePMWO(prev => {
                                            const newVal = !prev;
                                            //if (newVal) setIncludeCloseWO(false); // turn off other
                                            setCurrentPage(1); // reset page to 1 when filter changes
                                            return newVal;
                                        });
                                    }}
                                >
                                    Exclude PM Task
                                </Button>

                                <Button
                                    theme={includeCloseWO ? 'blue' : 'light'}
                                    className='!rounded-none !border-0 px-3'
                                    onClick={() => {
                                        setIncludeCloseWO(prev => {
                                            const newVal = !prev;
                                            //if (newVal) setIncludePMWO(false); // turn off other
                                            setCurrentPage(1);
                                            return newVal;
                                        });
                                    }}
                                >
                                    Include Closed Task
                                </Button>
                            </div>


                        </div>

                        {/* Table Section */}
                        <div className="ag-theme-alpine px-4 w-full h-1/2">
                            {loading ? (
                                <div className="flex items-center justify-center h-64">
                                    <Loader />
                                </div>
                            ) : (
                                <AgGridReact
                                    columnDefs={columnDefs as any}
                                    rowData={rowData || []}
                                    rowSelection="multiple"
                                    onGridReady={onGridReady}
                                    pagination={false}
                                    domLayout="autoHeight"
                                    onRowClicked={onRowClicked}
                                    loadingOverlayComponent={Loader}
                                    noRowsOverlayComponent={() => (
                                        <div className="flex items-center justify-center h-full">
                                            <div className="text-center text-gray-500">
                                                <div className="text-lg font-medium">No Data Found</div>
                                            </div>
                                        </div>
                                    )}
                                />
                            )}
                        </div>
                    </div>

                    {/* <CreateSubFacilitiesModal _ref={createSubFacilityModalRef} facilityId={subFacilityFor} /> */}
                    <Filters _ref={filtersRef} config={filterConfig} filters={filters} onUpdate={(data) => {
                        console.log('On Submit Filters =>', data);
                        setFilters(data);
                    }} />
                </>
            )}
            {view == 'kanban' && (
                <KanbanViewWorkOrder canEdit={getPermissionInfo(location.pathname, "Edit", loggedinuser)} />
            )}
            {view == 'calendar' && (
                <CalendarWO createWorkOrderOn={createWorkOrderOn} createScheduleOn={createScheduleOn} canEdit={getPermissionInfo(location.pathname, "Edit", loggedinuser)} />
            )}
        </Layout>
    );
};

export default WorkOrder;